import { useState } from "react";
import { useTranslation } from "react-i18next";
import AuthSignInTabComponent from "../../../components/AuthSignInFanTabComponent";
import AuthGoogleUnavailableComponent from "../../../components/AuthGoogleUnavailableComponent";
import useSignInPageInfos from "../../../hooks/global/useSignInPageInfos";

const SignInPage = () => {
  const { t } = useTranslation();
  useSignInPageInfos(t);
  const [authGoogleUnavailable, setAuthGoogleUnavailable] = useState<boolean>(false);

  const googleUnavailable = () => {
    setAuthGoogleUnavailable(true);
  };

  const googleUnavailableCancel = () => {
    setAuthGoogleUnavailable(false);
  };

  return (
    <>
      {authGoogleUnavailable ? (
        <AuthGoogleUnavailableComponent cancel={googleUnavailableCancel} />
      ) : (
        <>
          <h1 className="seo-hidden">{t("signin-page-h1")}</h1>
          <AuthSignInTabComponent googleUnavailable={googleUnavailable} />
        </>
      )}
    </>
  );
};

export default SignInPage;
